<template>
    <div>
        <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />
        <div class="uploadMethoRadio">
            <tl-radio name="uploadType" label="Bulk Upload" id="bulkUpload" value="bulkUpload" v-model="uploadMethod" />
        </div>
        <pop-up-message v-if="showSuccessMsg" :message="successMsg" btnText="Back" @back="backfrompopup()" />
        <pop-up-message v-if="showErrorPopup" message="" popupType="Warning" :popupHeaderMessage="'UPLOAD FAILED!!!'">
            <template v-slot:bottomContent>
                <div class=" margintop-32">
                    <div class="Rectangle margintop-32">
                        <span class="Information-message">{{ logMessage }}</span>
                    </div>
                </div>
                <div class="margintop-32 custom-container">
                    <a :href="logSheetUrl" @click="downloadItem(logSheetUrl)"><img src="@/assets/download.svg"
                            class="img" />
                        <span class="text">Error Log Sheet</span></a>
                </div>
                <div class="popup-btn-group margintop-32 marginright" :key="componentKey">
                    <button class="btn-popup" type="button" @click="backfrompopup()">Back To Salary Deletion</button>
                </div>
            </template>
        </pop-up-message>
        <div class="bulkUploadClass">
            <div class="download-btn">
                <download-button @downloadTemplate="getTemplate()"></download-button>
            </div>
            <div class="margin-t-15px" :key="componentKey">
                <upload :tobucket="false" @change="onUploadTemplate($event)"></upload>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
    data() {
        return {
            componentKey: 0,
            showSuccessMsg: false,
            showErrorPopup: false,
            successMsg: '',
            toast: false,
            errmsg: '',
            logSheetUrl: '',
            uploadMethod: 'bulkUpload'
        }
    },
    computed: {
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID"
        }),
        le_id() {
            if (this.$route.params.entity_index)
                return this.getleid(this.$route.params.entity_index);
            else return this.getleid(0);
        },
        ...mapState({
            email: state => state.auth.email,
            payrollMonth: state => state.payroll.runpayroll.payrollMonth,
            payrollYear: state => state.payroll.runpayroll.payrollYear
        }),
    },
    methods: {
        ...mapActions({
            act_get_template: 'dashboard/payroll/utilities/revisesalary/getSalaryDeletionTemplate',
            act_upload: 'dashboard/payroll/utilities/revisesalary/uploadSalaryDeletionTemplate'
        }),

        async getTemplate() {
            await this.act_get_template(this.le_id)
        },
        async onUploadTemplate(event) {
            try {
                let formData = new FormData();
                formData.append("file", event);
                formData.append("le_id", this.le_id);
                formData.append("loggedInUser", this.email);
                formData.append("payroll_month", this.payrollMonth.toLowerCase().substring(0,3));
                formData.append("payroll_year", this.payrollYear)
                let result = await this.act_upload(formData);
                if (result && result.status && result.data && result.data.statusCode == 200) {
                    if (result.data.payload && result.data.payload.length) {
                        this.showErrorPopup = true
                        this.logSheetUrl = result.data.payload[0]
                    } else {
                        this.showSuccessMsg = true;
                        this.successMsg = result.data.message;
                    }
                }
            } catch (err) {
                this.toast = true;
                this.errmsg = err
            }
        },
        backfrompopup() {
            this.componentKey += 1;
            this.showSuccessMsg = false;
            this.showErrorPopup = false;
        },
    },
}
</script>
<style lang="scss" scoped>
.uploadMethoRadio {
    display: flex;
}

.download-btn {
    margin-top: 2%;
}
</style>